import { render, staticRenderFns } from "./actions-panel.vue?vue&type=template&id=1c08bf42&scoped=true"
import script from "./actions-panel.vue?vue&type=script&lang=js"
export * from "./actions-panel.vue?vue&type=script&lang=js"
import style0 from "./actions-panel.vue?vue&type=style&index=0&id=1c08bf42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08bf42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
